import { createBrowserRouter } from 'react-router-dom';

// project imports
import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';
import NotFound from '../components/NotFound';

// ==============================|| ROUTING RENDER ||============================== //

const router = createBrowserRouter([
  MainRoutes,
  LoginRoutes, 
  {
    path: '*',
    element: <NotFound />
  }
]);

export default router;
